import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardLayoutComponent from "./components/DashboardLayout";

export const queryClient = new QueryClient();

const DashboardLayout = ({ children, navigation }: any) => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <DashboardLayoutComponent children={children} navigation={navigation} />
      </BrowserRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
};

export default DashboardLayout;
